import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { defaultMapBounds } from '~/utilities';

export interface MapDataState {
  mapInteractionActive: boolean;
  mapBounds: google.maps.LatLngBoundsLiteral;
}

export const initialState: MapDataState = {
  mapInteractionActive: false,
  mapBounds: defaultMapBounds,
};

export const mapDataSlice = createSlice({
  name: 'mapData',
  initialState,
  reducers: {
    setMapInteractionActive: (state, action: PayloadAction<boolean>) => {
      if (state.mapInteractionActive !== action.payload) {
        state.mapInteractionActive = action.payload;
      }
    },
    setMapBounds: (
      state,
      action: PayloadAction<google.maps.LatLngBoundsLiteral>
    ) => {
      state.mapBounds = action.payload;
    },
    resetMapBounds: (state) => {
      state.mapBounds = defaultMapBounds;
      state.mapInteractionActive = false;
    },
  },
});

type SliceState = { mapData: MapDataState };
export const selectMapBounds = (state: SliceState) => state.mapData.mapBounds;
export const selectMapInteractionActive = (state: SliceState) =>
  state.mapData.mapInteractionActive;
export const { setMapBounds, setMapInteractionActive, resetMapBounds } =
  mapDataSlice.actions;

export default mapDataSlice.reducer;
